/**
 * The docs sidebar, in reading order. Shared by `zudoku.config.tsx` and the
 * post-build step, which orders llms.txt the same way. Plain data, no React,
 * so Node can import it (scripts/postprocess-build.mjs).
 */
export type DocsGroup = {
  type: "category";
  label: string;
  icon: string;
  items: string[];
};

export const docsGroups: DocsGroup[] = [
  {
    type: "category",
    label: "Get started",
    icon: "rocket",
    items: ["introduction", "quickstart", "concepts"],
  },
  {
    type: "category",
    label: "Uptime monitors",
    icon: "activity",
    items: [
      "monitors/introduction",
      "monitors/http",
      "monitors/ping",
      "monitors/tcp",
      "monitors/dns",
      "monitors/nameserver",
      "monitors/mail-servers",
      "monitors/heartbeats",
      "monitors/locations-and-checks",
      "monitors/performance",
      "monitors/certificates",
      "monitors/pause-and-delete",
    ],
  },
  {
    type: "category",
    label: "Servers",
    icon: "server",
    items: [
      "hosts/introduction",
      "hosts/install-the-agent",
      "hosts/metrics",
      "hosts/health-checks",
      "hosts/metric-conditions",
    ],
  },
  {
    type: "category",
    label: "Domains",
    icon: "globe",
    items: ["domains/introduction", "domains/checks"],
  },
  {
    type: "category",
    label: "Alerts and on-call",
    icon: "bell-ring",
    items: [
      "alerting/alerts",
      "alerting/escalation-paths",
      "alerting/maintenance-windows",
      "alerting/channels",
      "alerting/webhooks",
      "alerting/on-call",
      "alerting/notification-rules",
      "alerting/alert-sources",
      "alerting/slack",
      "alerting/discord",
      "alerting/telegram-and-phone",
    ],
  },
  {
    type: "category",
    label: "Incidents",
    icon: "siren",
    items: [
      "incidents/introduction",
      "incidents/updates-and-roles",
      "incidents/postmortems",
    ],
  },
  {
    type: "category",
    label: "Status pages",
    icon: "panels-top-left",
    items: [
      "status-pages/introduction",
      "status-pages/components",
      "status-pages/incidents",
      "status-pages/maintenance",
      "status-pages/subscribers",
      "status-pages/custom-domains",
      "status-pages/appearance",
      "status-pages/access",
      "status-pages/issue-reports",
      "status-pages/json-api",
      "status-pages/intercom",
    ],
  },
  {
    type: "category",
    label: "Team and account",
    icon: "users",
    items: [
      "account/teams-and-roles",
      "account/members",
      "account/sign-in-and-security",
      "account/projects",
      "account/plans-and-billing",
      "account/data-and-privacy",
    ],
  },
  {
    type: "category",
    label: "Developers",
    icon: "code",
    items: ["developers/api", "developers/api-tokens", "developers/mcp"],
  },
  {
    type: "category",
    label: "Help",
    icon: "life-buoy",
    items: ["faq/uptime-monitor-bot", "faq/ip-addresses"],
  },
];
